import React from 'react';
import {Row, Col, Input, Button} from 'antd';
import { useTranslation } from 'react-i18next';

const InfoCompliance = ({infoCom, actual, record}) => {
    const { t } = useTranslation();
    return (
        <div>
            <Row gutter={[32, 12]}>
                <Col span={22}>
                    {record.type === 'Person' ?
                    t("messages.aml.complianceQuestionPerson")
                    :
                    t("messages.aml.complianceQuestionEntity")
                    }
                </Col>
                <Col span={2} >
                    <Button type="primary" className={"no-btn radioDecision " + (actual && infoCom.hasCompliance !== actual.hasCompliance ? "difference" : "")}>
                        {infoCom.hasCompliance ? t("messages.aml.yes") : t("messages.aml.no")}
                    </Button>
                </Col>
            </Row>
            {infoCom.hasCompliance &&
                <>
                    <Row gutter={[32, 12]}>
                        <Col span={22}>
                            {t("messages.aml.hasComplianceOfficer")}
                        </Col>
                        <Col span={2} >
                            <Button type="primary" className={"no-btn radioDecision " + (actual && infoCom.hasOfCto !== actual.hasOfCto ? "difference" : "")}>
                                {infoCom.hasOfCto ? t("messages.aml.yes") : t("messages.aml.no")}
                            </Button>
                        </Col>
                    </Row>
                    {infoCom.hasOfCto &&
                        <Row gutter={[32, 12]}>
                            <Col span={8}>
                                {t("messages.aml.name")}
                                <Input
                                    readOnly
                                    value={infoCom.nombreCompliance}
                                    className={actual && infoCom.nombreCompliance !== actual.nombreCompliance && "difference"}
                                />
                            </Col>
                            <Col span={8}>
                                {t("messages.aml.email")}
                                <Input
                                    readOnly
                                    value={infoCom.correo}
                                    className={actual && infoCom.correo !== actual.correo && "difference"}
                                />
                            </Col>
                            <Col span={8}>
                                {t("messages.aml.landline")}
                                <Input
                                    readOnly
                                    value={infoCom.telefono}
                                    className={actual && infoCom.telefono !== actual.telefono && "difference"}
                                />
                            </Col>
                            <Col span={24}>
                                {t("messages.aml.observations")}
                                <Input.TextArea
                                    readOnly
                                    value={infoCom.descripcion}
                                    className={actual && infoCom.descripcion !== actual.descripcion && "difference"}
                                />
                            </Col>
                        </Row>
                    }
                </>
            }
        </div>
    );
};

export default InfoCompliance;